import { Search, Flame, Clock, Snowflake, Package } from "lucide-react";
import { InterestBadge } from "../../lib/ui";
import { formatRp, timeWIB } from "../../lib/api";

const FILTERS = [
  { id: "all", label: "Semua" },
  { id: "hot", label: "Hot", icon: Flame },
  { id: "medium", label: "Medium", icon: Clock },
  { id: "cold", label: "Cold", icon: Snowflake },
];

export function ChatList({ chats, activeId, onSelect, filter, setFilter, q, setQ }) {
  return (
    <section className="flex h-screen w-[380px] shrink-0 flex-col border-r border-white/5 bg-panel">
      <div className="px-4 pb-3 pt-5">
        <h2 className="text-lg font-semibold">Chats</h2>
        <div className="relative mt-3">
          <Search size={14} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-faint" />
          <input data-testid="chat-search-input" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Cari nama atau nomor…"
            className="w-full rounded-full border border-white/10 bg-ink py-2 pl-9 pr-4 text-sm text-paper placeholder:text-faint focus:border-mint/50 focus:outline-none" />
        </div>
        <div className="mt-3 flex gap-2">
          {FILTERS.map(({ id, label, icon: Icon }) => (
            <button key={id} data-testid={`chat-filter-${id}`} onClick={() => setFilter(id)}
              className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                filter === id ? "bg-mint text-ink" : "border border-white/10 text-muted hover:text-paper"}`}>
              {Icon && <Icon size={11} />} {label}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto" data-testid="chat-list">
        {chats.map((c) => (
          <button key={c.id} data-testid={`chat-item-${c.id}`} onClick={() => onSelect(c.id)}
            className={`w-full border-b border-white/5 px-4 py-3 text-left transition-colors hover:bg-white/5 ${activeId === c.id ? "bg-white/5" : ""}`}>
            <div className="flex items-center gap-3">
              <div className="relative shrink-0">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-panel3 text-sm font-semibold text-mint">
                  {(c.name || c.phone || "?").slice(0, 2).toUpperCase()}
                </span>
                {c.processing && <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-panel bg-mint" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="truncate text-sm font-semibold">{c.name || c.phone}</p>
                  <span className="shrink-0 font-mono text-[10px] text-faint">{timeWIB(c.last_message_at)}</span>
                </div>
                <div className="mt-0.5 flex items-center justify-between gap-2">
                  <p className="truncate text-xs text-muted">{c.last_message}</p>
                  {c.unread > 0 ? (
                    <span className="shrink-0 rounded-full bg-mint px-1.5 py-0.5 font-mono text-[10px] font-bold text-ink">{c.unread}</span>
                  ) : (
                    <InterestBadge level={c.interest_level} />
                  )}
                </div>
                {(c.selected_products?.length > 0 || c.estimated_revenue > 0) && (
                  <div className="mt-1.5 flex items-center justify-between gap-2">
                    <span className="flex min-w-0 items-center gap-1 text-[11px] text-faint">
                      <Package size={11} className="shrink-0" />
                      <span className="truncate">{(c.selected_products || []).map((p) => p.name).join(", ")}</span>
                    </span>
                    <span className="shrink-0 font-mono text-[11px] text-mint">{formatRp(c.estimated_revenue)}</span>
                  </div>
                )}
              </div>
            </div>
          </button>
        ))}
        {!chats.length && (
          <p className="px-4 py-8 text-center text-sm text-faint">Belum ada percakapan. Coba kirim pesan lewat Simulator.</p>
        )}
      </div>
    </section>
  );
}
